export default __webpack_public_path__ + "static/media/Icon-my-scan.64fb20ac.svg";